export interface CourseDef {
  productCode: string;
  code: string;
  name: string;
  startPageNumber: number;
  endingPageNumber: number;
  version: string | null;
}

export const COURSE_DEFS: CourseDef[] = [
  {productCode: 'en', code: 'en.s1', name: 'English Stage 1', startPageNumber: 1, endingPageNumber: 52, version: null},
  {productCode: 'en', code: 'en.s2', name: 'English Stage 2', startPageNumber: 53, endingPageNumber: 128, version: null},
  {productCode: 'en', code: 'en.s3', name: 'English Stage 3', startPageNumber: 129, endingPageNumber: 210, version: null},
  {productCode: 'en', code: 'en.s4', name: 'English Stage 4', startPageNumber: 211, endingPageNumber: 314, version: null},
  {productCode: 'en', code: 'en.s5', name: 'English Stage 5', startPageNumber: 315, endingPageNumber: 414, version: null},
  {productCode: 'en', code: 'en.s6', name: 'English Stage 6', startPageNumber: 415, endingPageNumber: 504, version: null},
  {productCode: 'en', code: 'en.s7', name: 'English Stage 7', startPageNumber: 505, endingPageNumber: 602, version: null},
  {productCode: 'en', code: 'en.s8', name: 'English Stage 8', startPageNumber: 603, endingPageNumber: 696, version: null},
  {productCode: 'en', code: 'en.s9', name: 'English Stage 9', startPageNumber: 697, endingPageNumber: 822, version: null},
  {productCode: 'en', code: 'en.s10', name: 'English Stage 10', startPageNumber: 823, endingPageNumber: 940, version: null},
  {productCode: 'en', code: 'en.s11', name: 'English Stage 11', startPageNumber: 941, endingPageNumber: 1068, version: null},
  {productCode: 'en', code: 'en.s12', name: 'English Stage 12', startPageNumber: 1069, endingPageNumber: 1201, version: null},

  {productCode: 'en', code: 'en.s1', name: 'English Stage 1', startPageNumber: 1, endingPageNumber: 81, version: '3'},
  {productCode: 'en', code: 'en.s2', name: 'English Stage 2', startPageNumber: 82, endingPageNumber: 170, version: '3'},
  {productCode: 'en', code: 'en.s3', name: 'English Stage 3', startPageNumber: 171, endingPageNumber: 269, version: '3'},
  {productCode: 'en', code: 'en.s4', name: 'English Stage 4', startPageNumber: 270, endingPageNumber: 390, version: '3'},
  {productCode: 'en', code: 'en.s5', name: 'English Stage 5', startPageNumber: 391, endingPageNumber: 507, version: '3'},
  {productCode: 'en', code: 'en.s6', name: 'English Stage 6', startPageNumber: 508, endingPageNumber: 624, version: '3'},
  {productCode: 'en', code: 'en.s7', name: 'English Stage 7', startPageNumber: 625, endingPageNumber: 746, version: '3'},
  {productCode: 'en', code: 'en.s8', name: 'English Stage 8', startPageNumber: 747, endingPageNumber: 866, version: '3'},
  {productCode: 'en', code: 'en.s9', name: 'English Stage 9', startPageNumber: 867, endingPageNumber: 990, version: '3'},
  {productCode: 'en', code: 'en.s10', name: 'English Stage 10', startPageNumber: 991, endingPageNumber: 1110, version: '3'},
  {productCode: 'en', code: 'en.s11', name: 'English Stage 11', startPageNumber: 1111, endingPageNumber: 1246, version: '3'},
  {productCode: 'en', code: 'en.s12', name: 'English Stage 12', startPageNumber: 1247, endingPageNumber: 1387, version: '3'},

  {productCode: 'en.bs', code: 'en.bs.s1', name: 'English for Business', startPageNumber: 1, endingPageNumber: 127, version: null},

  {productCode: 'en.ch', code: 'en.ch.s1', name: 'English for Children Stage 1', startPageNumber: 1, endingPageNumber: 72, version: null},
  {productCode: 'en.ch', code: 'en.ch.s2', name: 'English for Children Stage 2', startPageNumber: 73, endingPageNumber: 174, version: null},
  {productCode: 'en.ch', code: 'en.ch.s3', name: 'English for Children Stage 3', startPageNumber: 165, endingPageNumber: 270, version: null},
  {productCode: 'en.ch', code: 'en.ch.s4', name: 'English for Children Stage 4', startPageNumber: 271, endingPageNumber: 372, version: null},

  {productCode: 'sp', code: 'sp.s1', name: 'ESPAÑOL ETAPA 1', startPageNumber: 1, endingPageNumber: 100, version: null},
  {productCode: 'sp', code: 'sp.s2', name: 'ESPAÑOL ETAPA 2', startPageNumber: 101, endingPageNumber: 184, version: null},
  {productCode: 'sp', code: 'sp.s3', name: 'ESPAÑOL ETAPA 3', startPageNumber: 185, endingPageNumber: 301, version: null},
  {productCode: 'sp', code: 'sp.s4', name: 'ESPAÑOL ETAPA 4', startPageNumber: 302, endingPageNumber: 421, version: null},
  {productCode: 'sp', code: 'sp.s5', name: 'ESPAÑOL ETAPA 5', startPageNumber: 422, endingPageNumber: 536, version: null},
  {productCode: 'sp', code: 'sp.s6', name: 'ESPAÑOL ETAPA 6', startPageNumber: 537, endingPageNumber: 646, version: null},
];

export class CourseDefUtils {
  static findByCode(code?: string | null, productVersion?: string | null): CourseDef | null {
    if (!code) {
      return null;
    }
    return COURSE_DEFS.find((course) => course.code === code && course.version === (productVersion ?? null)) ?? null;
  }

  static findByProduct(productCode?: string | null, productVersion?: string | null): CourseDef[] {
    if (!productCode) {
      return [];
    }
    return COURSE_DEFS.filter((course) => course.productCode === productCode && course.version === (productVersion ?? null));
  }

  static findForPage(productCode?: string | null, page?: number | null, productVersion?: string | null): CourseDef | null {
    if (!productCode || page === undefined || page === null) {
      return null;
    }
    return this.findByProduct(productCode, productVersion)
      .find((course) => page <= course.endingPageNumber) ?? null;
  }
}
